import type { FaireProductEntity } from "../../entity_types/product";

export const p_6ku555n2wa: FaireProductEntity = {
  token: "p_6ku555n2wa",
  type: "product",
  name: "Crop Top N High Waist Leggings Set",
  brandToken: "b_2ig5ozgc",
  brandName: "Vanilla Monkey",
  imageUrl:
    "https://cdn.faire.com/fastly/90c6e9e5b75855db880743fa4b0e4c3231d7450a98ce273dae309df2337b0aa1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03241f418b08868916b1c1439fa52d860ded2d37c9d7c6fa57ddd43be389ed1c.jpeg",
    "https://cdn.faire.com/fastly/0f4dd8d6d439ad227cb6baa9fa91d3e71bd1ba5b318089662dac084d9db0ded7.jpeg",
    "https://cdn.faire.com/fastly/f272ab446021e580be679156fe299e8b6faacf5325b9bbb623e0f16579a2d501.jpeg",
    "https://cdn.faire.com/fastly/ff21e79378edab2217dbaf3b2bfdad2bf59a37aedc5a8ebe17e96e4197f37e2e.jpeg",
    "https://cdn.faire.com/fastly/f1764d736d19ed610490af9474d8ce2c72f918108ad9e970457549f6c4eeec99.jpeg",
  ],
  priceDollars: 12,
  description:
    "JR FIT\r\n\r\nROUND NECK DOUBLE LAYER EFFECT CROP TOP AND HIGH WAIST CONTRAST WAISTBAND LEGGINGS SET\r\n\r\nFabric Contents\r\nFABRIC: SEAMLESS\r\n92% NYLON 8% SPANDEX",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:27.694Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
